import { useMemo } from 'react'
import getReadableLabel from '../helpers/getReadableLabel'

export default function useAlertsBarChart( opts ) {
  const { result } = opts
  const {
    counts : { perCause },
  } = result

  const data = useMemo(
    () => Object.entries( perCause ?? {} ).map( ( [ k, v ] ) => ( {
      id : k,
      value : v,
    } ) ),

    [ perCause ],
  )

  const accessors = useMemo(
    () => Object.fromEntries(
      data?.map( ( cause, i ) => [
        cause.id,
        { xAccessor : () => cause.id, yAccessor : () => cause.value },
      ] ),
    ),
    [ data ],
  )

  const config = useMemo(
    () => ( {
      scale : {
        x : { type : 'band', padding : 0.3 },
        y : { type : 'linear' },
      },
      accessors,
      tickFormat : {
        x : v => getReadableLabel( v ),
      },
    } ),
    [ accessors ],
  )

  return {
    config,
    data,
  }
}
